import React, { useState } from 'react';
import Signature from './Signature';
import Form from './Form';

function App() {
    const [formData, setFormData] = useState({
        name: "John Doe",
        email: "john.doe@example.com",
        pronouns: "",
        title: "Program Coordinator",
        additionalInfo: "",
        unit: "Global Commercial Learning & Development",
        location: "Gilead Sciences",
        dsn: "555-123-4567"
    });

    function copyToClipboard() {
        const signatureElement = document.getElementById('signature-to-copy');
        const range = document.createRange();
        range.selectNode(signatureElement);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        alert('Signature copied to clipboard!');
    }

    return (
        <div className="App">
            <Form formData={formData} setFormData={setFormData} copyToClipboard={copyToClipboard} />
            <Signature formData={formData} />
        </div>
    );
}

export default App;
